export default {"src":"/_next/static/media/signup_icon_1.ff9394cd.svg","height":34,"width":29};